export default {
  name: 'sw',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'sawa',
      clear: 'futa',
      defaultLabel: 'kichagua rangi',
      description:
        'rangi ya sasa ni {color}. bonyeza kitufe cha kuingia ili kuchagua rangi mpya.',
    },
    datepicker: {
      now: 'sasa',
      today: 'leo',
      cancel: 'kufuta',
      clear: 'futa',
      confirm: 'sawa',
      dateTablePrompt:
        'Tumia vitufe vya vishale na uweke ili kuchagua siku katika mwezi',
      monthTablePrompt:
        'Tumia vitufe vya vishale na uingize ili kuchagua mwezi',
      yearTablePrompt: 'Tumia vitufe vya vishale na uingize ili kuchagua mwaka',
      selectedDate: 'tarehe iliyochaguliwa',
      selectDate: 'chagua tarehe',
      selectTime: 'chagua muda',
      startDate: 'siku ya kuanza',
      startTime: 'muda wa kuanza',
      endDate: 'tarehe ya mwisho',
      endTime: 'wakati wa mwisho',
      prevYear: 'mwaka uliopita',
      nextYear: 'mwaka ujao',
      prevMonth: 'mwezi uliopita',
      nextMonth: 'mwezi ujao',
      year: '',
      month1: 'mwezi wa kwanza',
      month2: 'mwezi wa pili',
      month3: 'mwezi tatu',
      month4: 'mwezi wa nne',
      month5: 'Mwezi wa tano',
      month6: 'mwezi wa sita',
      month7: 'mwezi wa saba',
      month8: 'mwezi wa nane',
      month9: 'mwezi wa tisa',
      month10: 'mwezi wa kumi',
      month11: 'mwezi wa kumi na moja',
      month12: 'mwezi wa kumi na mbili',
      week: 'siku saba',
      weeks: {
        sun: 'jpili',
        mon: 'jtatu',
        tue: 'jnne',
        wed: 'jtano',
        thu: 'alh',
        fri: 'jumaa',
        sat: 'jmosi',
      },
      weeksFull: {
        sun: 'jumapili',
        mon: 'jumatatu',
        tue: 'jumanne',
        wed: 'jumatano',
        thu: 'alhamisi',
        fri: 'ijumaaa',
        sat: 'jumamosi',
      },
      months: {
        jan: 'mwezi 1',
        feb: 'mwezi 2',
        mar: 'mwezi 3',
        apr: 'mwezi 4',
        may: 'mwezi 5',
        jun: 'mwezi 6',
        jul: 'mwezi 7',
        aug: 'mwezi 8',
        sep: 'mwezi 9',
        oct: 'mwezi 10',
        nov: 'mwezi 11',
        dec: 'mwezi 12',
      },
    },
    inputNumber: {
      decrease: 'kupunguza idadi',
      increase: 'kuongeza idadi',
    },
    select: {
      loading: 'inapakia',
      noMatch: 'hakuna data inayolingana',
      noData: 'hakuna data',
      placeholder: 'chagua',
    },
    dropdown: {
      toggleDropdown: 'geuza kunyuzi',
    },
    cascader: {
      noMatch: 'hakuna data inayolingana',
      loading: 'pakia',
      placeholder: 'chagua',
      noData: 'hakuna data',
    },
    pagination: {
      goto: 'enda kwenye',
      pagesize: '/kurasa',
      total: 'jumla {total}',
      pageClassifier: '',
      page: 'kurasa',
      prev: 'Nenda kwenye ukurasa uliopita',
      next: 'Nenda kwenye ukurasa unaofuata',
      currentPage: 'kurasa {pager}',
      prevPages: 'Kurasa za {pager} zilizopita',
      nextPages: 'Kurasa {pager} zinazofuata',
      deprecationWarning:
        'Matumizi yaliyoacha kutumika yamegunduliwa, tafadhali rejelea hati za el-pagination kwa maelezo zaidi',
    },
    dialog: {
      close: 'funga kidirisha hiki',
    },
    drawer: {
      close: 'funga kidirisha hiki',
    },
    messagebox: {
      title: 'ujumbe',
      confirm: 'sawa',
      cancel: 'futa',
      error: 'Uingizaji haramu',
      close: 'Funga kidirisha hiki',
    },
    upload: {
      deleteTip: 'bonyeza kufuta ili kuondoa',
      delete: 'kufuta',
      preview: 'hakikisho',
      continue: 'endelea',
    },
    slider: {
      defaultLabel: 'kitelelzi kati ya {min} na {max}',
      defaultRangeStartLabel: 'cahgua thamani ya kuanzia',
      defaultRangeEndLabel: 'chagua thamani ya mwisho',
    },
    table: {
      emptyText: 'hakuna data',
      confirmFilter: 'thibitisha',
      resetFilter: 'weka upya',
      clearFilter: 'zote',
      sumText: 'jumla',
    },
    tree: {
      emptyText: 'hakuna data',
    },
    transfer: {
      noMatch: 'hakuna data inayolingana',
      noData: 'hakuna data',
      titles: ['orodha ya kwanza', 'orodha ya pili'],
      filterPlaceholder: 'Ingiza neno kuu',
      noCheckedFormat: '{total} vitu',
      hasCheckedFormat: '{checked}/{total} imechaguliwa',
    },
    image: {
      error: 'imeshindwa',
    },
    pageHeader: {
      title: 'nyuma',
    },
    popconfirm: {
      confirmButtonText: 'ndio',
      cancelButtonText: 'hapana',
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
  },
}
